import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import type { ModpackConfig, ModpackConfigEnv } from '../../types/modpackConfig';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';
import { AnnounceLaunchPanel } from './AnnounceLaunchPanel';
import type { LaunchServer } from './AnnounceLaunchPanel';

interface AnnounceLaunchModalProps {
  config: ModpackConfig;
  /** The whole cluster, so the post can name every server. */
  members?: LaunchServer[];
  env: ModpackConfigEnv;
  onClose: () => void;
}

/** The launch announcement, reachable from the list without opening the pack. */
export const AnnounceLaunchModal = ({ config, members, env, onClose }: AnnounceLaunchModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(modalRef, onClose);

  return createPortal(
    <div className="modal-overlay z-[9999]">
      <div ref={modalRef} className="modal-panel max-w-2xl max-md:max-w-[95vw]" role="dialog" aria-modal="true">
        <div className="modal-header">
          <div className="min-w-0">
            <h2 className="modal-title">Announce {config.modpack_full_name || config.server_address}</h2>
            <p className="modal-subtitle font-mono">{config.server_address}</p>
          </div>
          <button type="button" onClick={onClose} className="modal-close" aria-label="Close">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="modal-body">
          <AnnounceLaunchPanel
            address={config.server_address}
            env={env}
            members={members}
            defaults={{
              location: config.region_name,
              version: config.modpack_version,
              url: config.server_download_url,
            }}
          />
        </div>
        <div className="modal-footer">
          <button type="button" onClick={onClose} className="glass-button-secondary ml-auto">Close</button>
        </div>
      </div>
    </div>,
    document.body,
  );
};
